"use client";
// eslint-disable-next-line import/no-named-as-default -- i need i18n
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// English translations
import authSignInEn from "../public/locales/en/auth-sign-in.json";
import authSignUpEn from "../public/locales/en/auth-sign-up.json";
import rootEn from "../public/locales/en/root.json";
import commonEn from "../public/locales/en/common.json";
import settingsEn from "../public/locales/en/settings.json";
import p404En from "../public/locales/en/404.json";
import unitsEn from "../public/locales/en/units.json";
import applicationIdEn from "../public/locales/en/applications-id.json";
import applicationsIdApplicantsEn from "../public/locales/en/applications-id-applicants.json";
import applicationsIdApplicantsInviteEn from "../public/locales/en/applications-id-applicants-invite.json";
import verificationsEn from "../public/locales/en/verifications.json";
import applicationsIdCheckoutEn from "../public/locales/en/applications-id-checkout.json";
import applicationsIdUploadDocumentsEn from "../public/locales/en/applications-id-upload-documents.json";
import applicationsIdMoveInDateEn from "../public/locales/en/applications-id-move-in-date.json";
import idvNotFinishedEn from "../public/locales/en/idv-not-finished.json";
import plaidErrorEn from "../public/locales/en/plaid-error.json";
import applicationIdVerificationsEn from "../public/locales/en/applications-id-verifications-id-verified-income.json";
import unableToCheckOutEn from "../public/locales/en/unable-to-checkout.json";
// Spanish translations
import authSignInEs from "../public/locales/es/auth-sign-in.json";
import authSignUpEs from "../public/locales/es/auth-sign-up.json";
import rootEs from "../public/locales/es/root.json";
import commonEs from "../public/locales/es/common.json";
import settingsEs from "../public/locales/es/settings.json";
import p404Es from "../public/locales/es/404.json";
import unitsEs from "../public/locales/es/units.json";
import applicationIdEs from "../public/locales/es/applications-id.json";
import applicationsIdApplicantsEs from "../public/locales/es/applications-id-applicants.json";
import applicationsIdApplicantsInviteEs from "../public/locales/es/applications-id-applicants-invite.json";
import verificationsEs from "../public/locales/es/verifications.json";
import applicationsIdCheckoutEs from "../public/locales/es/applications-id-checkout.json";
import applicationsIdUploadDocumentsEs from "../public/locales/es/applications-id-upload-documents.json";
import applicationsIdMoveInDateEs from "../public/locales/es/applications-id-move-in-date.json";
import idvNotFinishedEs from "../public/locales/es/idv-not-finished.json";
import plaidErrorEs from "../public/locales/es/plaid-error.json";
import applicationIdVerificationsEs from "../public/locales/es/applications-id-verifications-id-verified-income.json";
import unableToCheckOutEs from "../public/locales/es/unable-to-checkout.json";

// eslint-disable-next-line import/no-named-as-default-member -- i need i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "en", // default language
    fallbackLng: "en",
    resources: {
      en: {
        "unable-to-checkout": unableToCheckOutEn,
        "applications-id-verifications-id-verified-income":
          applicationIdVerificationsEn,
        "idv-not-finished": idvNotFinishedEn,
        "plaid-error": plaidErrorEn,
        "auth-sign-in": authSignInEn,
        "auth-sign-up": authSignUpEn,
        root: rootEn,
        settings: settingsEn,
        "404": p404En,
        units: unitsEn,
        "applications-id": applicationIdEn,
        "applications-id-applicants": applicationsIdApplicantsEn,
        "applications-id-applicants-invite": applicationsIdApplicantsInviteEn,
        "applications-id-checkout": applicationsIdCheckoutEn,
        "applications-id-upload-documents": applicationsIdUploadDocumentsEn,
        "applications-id-move-in-date": applicationsIdMoveInDateEn,
        verifications: verificationsEn,
        common: commonEn
      },
      es: {
        "unable-to-checkout": unableToCheckOutEs,
        "applications-id-verifications-id-verified-income":
          applicationIdVerificationsEs,
        "plaid-error": plaidErrorEs,
        "idv-not-finished": idvNotFinishedEs,
        "auth-sign-in": authSignInEs,
        "auth-sign-up": authSignUpEs,
        root: rootEs,
        settings: settingsEs,
        "404": p404Es,
        units: unitsEs,
        "applications-id": applicationIdEs,
        "applications-id-applicants": applicationsIdApplicantsEs,
        "applications-id-applicants-invite": applicationsIdApplicantsInviteEs,
        "applications-id-checkout": applicationsIdCheckoutEs,
        "applications-id-upload-documents": applicationsIdUploadDocumentsEs,
        "applications-id-move-in-date": applicationsIdMoveInDateEs,
        verifications: verificationsEs,
        common: commonEs
      }
    },
    // ignoreJSONStructure: false,
    interpolation: {
      escapeValue: false // React escapes by default
    }
  });

export default i18n;
